import { parseAmount } from "../services/utils";
import useApiService from "./useApiService";

const useCustomer = () => {
  const { get } = useApiService();

  const fetchAllCustomers = async () => {
    try {
      const response = await get("/api/customers");
      if (response.status && response.data) {
        return {
          customers: response.data.map((customer) => ({
            ...customer,
            id: customer.customer_id,
            customer_name: customer.customer_name === "N/A" ? "" : customer.customer_name,
            total_client_payment: parseAmount(customer.total_client_payment),
            total_paid: parseAmount(customer.total_paid),
            client_payment_due_now: parseAmount(customer.client_payment_due_now),
            total_upcoming: parseAmount(customer.total_upcoming),
          })),
        };
      } else {
        throw new Error("Unable to fetch customers");
      }
    } catch (error) {
      return { error };
    }
  };

  const fetchCustomerById = async (id) => {
    try {
      const response = await get(`/api/customers/${id}`);
      if (response.status && response.data) {
        const customer = response.data;
        return {
          customer: {
            customer: {
              id: customer.id,
              name: customer.name === "N/A" ? "" : customer.name,
              contact: customer.mobile,
              email: customer.email,
              age: customer.age,
              gender: customer.gender,
              occupation: customer.occupation,
              address: customer.address,
              aadhar_document_id: customer.customer_aadhar?.id,
              aadhar_document_url: customer.customer_aadhar?.url,
              pan_document_id: customer.customer_pan?.id,
              pan_document_url: customer.customer_pan?.url,
              photo_id: customer.customer_photo?.id,
              photo_url: customer.customer_photo?.url,
            },
            plots: {
              count: customer.total_plots_bought,
              plots_bought: customer.plots_bought
                .map((plot) => ({
                  ...plot,
                  id: plot.booking_id,
                }))
                .reverse(),
            },
            bank: {
              id: customer.bank_id,
              name_in_bank: customer.customer_name_in_bank,
              bank_name: customer.bank_name,
              bank_account_type: customer.bank_account_type,
              bank_account_number: customer.bank_account_number,
              bank_ifsc: customer.bank_ifsc,
              bank_branch: customer.bank_branch,
              bank_identification: customer.bank_identification?.id,
              bank_identification_url: customer.bank_identification?.url,
            },
          },
        };
      } else {
        throw new Error("Unable to fetch customer");
      }
    } catch (error) {
      return { error };
    }
  };

  const getCustomerNames = async () => {
    const { customers, error } = await fetchAllCustomers();
    if (error) return { error };
    return {
      customers: customers.map((customer) => ({
        id: customer.id,
        name: customer.customer_name,
      })),
    };
  };

  return {
    fetchAllCustomers,
    fetchCustomerById,
    getCustomerNames,
  };
};

export default useCustomer;
